<template>
  <div class="ui-item">
    <div class="item-wrapper"
         :class="{ 'img-col': isCol}">
      <p class="ui-item-title">
        {{itemInfo.title}}
      </p>
      <ul class="img-wrapper">
        <!-- 图集 -->
        <li class="img-list-wrapper"
            v-if="itemInfo.articleType === 1">
          <div class="item-img"
               v-for="(item, index) in itemInfo.imgList"
               :key="`${item}${index}`">
            <img v-lazy="formatImgUrl(item)"
                 class="img-response" />
            <div class="live-txt tag"
                 v-show="itemInfo.articleType == 6">
              <i class="point"></i>
              <span>直播</span>
            </div>
            <div class="audio-sign tag"
                 v-show="itemInfo.articleType === 9">
              <i class="icon-audio"></i>
              <span class="txt">{{itemInfo.videoTime | resolveMedioTime}}</span>
            </div>
          </div>
        </li>
        <!-- 小图大图 -->
        <li class="item-img"
            v-if="itemInfo.articleType !== 1 && articalImg">
          <img v-lazy="formatImgUrl(articalImg)"
               class="img-response" />
          <div class="live-txt tag"
               v-show="itemInfo.articleType == 6">
            <i class="point"></i>
            <span>直播</span>
          </div>
          <div class="audio-sign tag"
               v-show="itemInfo.articleType === 9">
            <i class="icon-audio"></i>
            <p class="txt">{{itemInfo.videoTime | resolveMedioTime}}</p>
          </div>
          <div class="icon-vedio"
               v-show="itemInfo.articleType === 2"></div>
        </li>
      </ul>
      <div class="date">
        <!-- <div class="info icon-wrapper" v-show="itemInfo.art_nfh_icon">
          <img :src="itemInfo.art_nfh_icon" class="img-response">
        </div> -->
        <!-- <span class="info des" v-show="itemInfo.releaseColName">{{itemInfo.releaseColName}}</span> -->
        <span class="info time">{{itemInfo.publishtime | resolveTime}}</span>
        <span class="info to-top" v-if="itemInfo.top==1">置顶</span>
        <span class="info"
              v-show="isShowTag"
              :class="tagStyleClass">{{itemInfo.tag}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { articleType } from '@common/dictionary'
// 30分钟毫秒数
const MESC_30MIN = 1800000
export default {
  name: 'nfItem',
  props: {
    // 新闻标题
    title: {
      type: String,
      default: ''
    },
    // 新闻图片列表
    imgList: {
      type: Array,
      default() {
        return []
      }
    },
    // 新闻时间
    time: {
      type: [String, Number],
      default: ''
    },
    // 是否置顶
    isToTop: {
      type: Boolean,
      default: false
    },
    iconImg: {
      type: String,
      default: 'sdasd'
    },
    releaseColName: {
      type: String,
      default: ''
    },
    // 文章类型
    articleType: {
      type: [String, Number],
      default: ''
    },
    itemInfo: {
      type: Object,
      default() {}
    }
  },
  filters: {
    resolveTime(value) {
      if (!value) return ''
      value = value.toString()
      value = value.split('.')[0].replace(/-/g, '/')
      let pubDate = new Date(value)
      let nowDate = new Date()
      let ret = ''
      let pubDateMon =
        pubDate.getMonth().toString().length < 2
          ? '0' + pubDate.getMonth().toString()
          : pubDate.getMonth().toString()
      let pubDateDate =
        pubDate.getDate().toString().length < 2
          ? '0' + pubDate.getDate().toString()
          : pubDate.getDate().toString()
      let nowDateMon =
        nowDate.getMonth().toString().length < 2
          ? '0' + nowDate.getMonth().toString()
          : nowDate.getMonth().toString()
      let nowDateDate =
        nowDate.getDate().toString().length < 2
          ? '0' + nowDate.getDate().toString()
          : nowDate.getDate().toString()
      let pubDateNum =
        pubDate.getFullYear() + '' + pubDateMon + '' + pubDateDate
      let nowDateNum =
        nowDate.getFullYear() + '' + nowDateMon + '' + nowDateDate
      let pubDateMinu = pubDate.getTime()
      let nowDateMinu = nowDate.getTime()
      let minuDis = nowDateMinu - pubDateMinu

      let isBeforeYesterday = nowDateNum - pubDateNum >= 1
      if (isBeforeYesterday) {
        ret =
          pubDate.getFullYear() +
          '-' +
          (parseInt(pubDate.getMonth()) + 1) +
          '-' +
          pubDate.getDate()
      } else {
        let reg = /.+\s(\d+:\d+):\d+(\.\d+)?/g
        ret = value.replace(reg, (p1, p2) => {
          return p2
        })
        // 30分钟之前显示刚刚
        if (minuDis <= MESC_30MIN) {
          ret = '刚刚'
        }
        // else if (minuDis <= 300000) {
        //   ret = `${Math.ceil(minuDis / 60000)}分钟前`
        // }
      }

      return ret
    },
    resolveMedioTime(value) {
      if (!value) return
      value = value.toString()
      let minu = Math.floor(value / 60)
      let h = Math.floor(value / 3600)
      let sec = Math.round(value % 60)
      let time = ''
      if (h) {
        h.toString().length < 2 && (h = '0' + h.toString())
        time += h + ':'
      }
      minu.toString().length < 2 && (minu = '0' + minu.toString())
      time += minu + ':'
      sec.toString().length < 2 && (sec = '0' + sec.toString())
      time += sec
      return time
    }
  },
  computed: {
    articleTypeMap() {
      return articleType
    },
    articalImg() {
      return this.itemInfo.picSmall
        ? this.itemInfo.picSmall : ''
    },
    isCol() {
      return (this.itemInfo.articleType == 1 &&
        this.itemInfo.imgList.length > 1) ? true : false
    },
    // 是否显示标签，为南方号或者空不显示
    isShowTag() {
      return (
        this.itemInfo.tag &&
        this.itemInfo.tag !== '南方号' &&
        this.itemInfo.tag !== '置顶'
      )
    },
    // 标签样式
    // 活动 - 蓝色框框 文本 3a84e9
    // 广告、推广、咨询 背景颜色灰色文本颜色灰色框框
    // 除了以上这种情况之外的情况 取tagStyle，tagStyle - 001 - f64e45，tagStyle - 002 - 3a84e9
    tagStyleClass() {
      let tag = this.itemInfo.tag
      let tagStyle = this.itemInfo.tagStyle
      let tagClass = ''
      if (tag === '广告' || tag === '推广' || tag === '资讯') {
        tagClass = 'border-txt-gray'
      } else if (tag === '活动') {
        tagClass = 'border-txt-blue'
      } else if (tagStyle.indexOf('001') > -1) {
        tagClass = 'txt-red'
      } else {
        tagClass = 'txt-blue'
      }
      return tagClass
    }
  },
  methods: {
    formatImgUrl(url) {
      if (url.indexOf('?') > -1) {
        return url + '&x-oss-process=style/w320'
      } else {
        return url + '?x-oss-process=style/w320'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-item {
  width: 100%;
  //   background: #ffffff;
  padding: 0.24rem 0.3rem 0 0.3rem;
  .item-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 0rem;
    .ui-item-title {
      font-family: PingFangSC-Regular;
      font-size: 0.34rem;
      color: #333333;
      letter-spacing: 0;
      line-height: 0.5rem;
      width: 4.36rem;
      flex: none;
      white-space: normal;
      word-break: break-all;
      min-height: 1rem;
      flex-grow: 1;
      // white-space: pre-wrap;
      word-break: break-all;
      display: -webkit-box;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      overflow: hidden;
      box-sizing: content-box;
      margin-bottom: 0.5rem;
    }
    .img-wrapper {
      max-width: 100%;
      overflow: auto;
      flex: none;
      display: flex;
      flex-wrap: nowrap;
      .img-list-wrapper {
        display: flex;
      }
      .item-img {
        flex: none;
        border-radius: 0.05rem;
        height: 1.68rem;
        width: 2.24rem;
        overflow: hidden;
        margin-right: 0.1rem;
        position: relative;
        margin-left: 0.3rem;
        display: flex;
        justify-content: center;
        border: 1px solid #eeeeee;
        .live-txt {
          position: absolute;
          right: 0.1rem;
          bottom: 0.12rem;
          width: 0.88rem;
          height: 0.34rem;
          border-radius: 0.08rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 0.2rem;
          background: rgba(246, 78, 69, 0.8);
          .point {
            width: 0.1rem;
            height: 0.1rem;
            background: #ffffff;
            border-radius: 50%;
            margin-right: 0.05rem;
          }
        }
        .tag {
          height: 0.3rem;
          width: auto;
          padding: 0 0.1rem;
          line-height: 0.3rem;
          color: #ffffff;
          font-size: 0.2rem;
          font-family: PingFangSC-Regular;
          position: absolute;
          right: 0.12rem;
          bottom: 0.1rem;
          display: flex;
          align-items: center;
        }
        .audio-sign {
          background: rgba(0, 0, 0, 0.6);
          border-radius: 0.04rem;
          display: flex;
          align-items: center;
          .icon-audio {
            display: inline-block;
            width: 0.3rem;
            height: 0.3rem;
            background: url('./images/icon-audio.png') no-repeat center;
            background-size: 65%;
            margin-right: 0.04rem;
          }
          .txt {
            height: 0.6rem;
            line-height: 0.64rem;
            font-size: 0.4rem;
            transform: scale(0.5);
            margin: 0 -0.22rem;
          }
        }
        .icon-vedio {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 0.6rem;
          height: 0.6rem;
          background: url('./images/icon_play@2x.png') no-repeat center;
          background-size: 100%;
          transform: translate3d(-50%, -50%, 0);
        }
        &:last-child {
          margin-right: 0;
        }
        .img-response {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &.big-img{
          margin-left: 0;
        }
      }
      &.big-img {
        width: 100%;
        height: 3.88rem;
        .item-img {
          height: 100%;
          width: 100%;
        }
        .icon-vedio {
          width: 0.9rem;
          height: 0.9rem;
        }
      }
    }
    .date {
      font-family: PingFangSC-Regular;
      font-size: 0.22rem;
      color: #999999;
      width: 100%;
      height: 0.3rem;
      flex: none;
      display: flex;
      align-items: center;
      .icon-wrapper {
        height: 0.32rem;
        width: 0.32rem;
        border-radius: 50%;
        overflow: hidden;
      }
      .info {
        display: inline-block;
        transform: translate3d(0, -0.3rem, 0);
        line-height: 0.32rem;
        margin-right: 0.2rem;
        border-radius: 0.01rem;
        line-height: 0.32rem;
        height: 0.32rem;
        font-size: 0.22rem;
        &.des {
          max-width: 1.7rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        &:last-child {
          margin-left: 0;
        }
      }
      .to-top {
        color: #f64e45;
      }
      .border-txt-gray {
        border: 1px solid #dddddd;
        color: #999999;
        padding: 0 0.08rem;
      }
      .border-txt-blue {
        border: 1px solid #3a84e9;
        color: #3a84e9;
        padding: 0 0.08rem;
      }
      .txt-red {
        color: #f64e45;
      }
      .txt-blue {
        color: #3a84e9;
      }
    }
    &.img-col {
      padding-bottom: 0.3rem;
      .ui-item-title {
        width: 100%;
        padding-bottom: 0;
        height: auto;
        min-height: auto;
        margin-bottom: 0;
      }
      .img-wrapper {
        margin: 0.2rem 0;
        .item-img {
          margin-left: 0;
        }
      }
      .date .info {
        transform: translate3d(0, 0, 0);
      }
    }
  }
}
</style>


